import React from 'react';
import { Dialog } from '@mui/material';
import TAGPickerButtonGroup from './TAGPickerButtonGroup';

var TAGPickerDialogWrapper = function TAGPickerDialogWrapper(props) {
  return React.createElement(Dialog, {
    open: props.open,
    onClose: props.onAccept
  }, props.children, React.createElement(TAGPickerButtonGroup, {
    onAccept: props.onAccept,
    onClear: props.onClear,
    onDismiss: props.onDismiss,
    onSetToday: props.onSetToday,
    cancelText: props.cancelText,
    clearable: props.clearable,
    clearText: props.clearText,
    okText: props.okText,
    showTodayButton: props.showTodayButton,
    todayText: props.todayText,
    color: props.color || 'secondary'
  }));
};

export default TAGPickerDialogWrapper;